import { HelpContent } from './types';
import * as jsonContent from './help-data-json';

export const helpContentData:HelpContent[] = [
  {
    helpId:'products',
    content: jsonContent.productsList,
  },
  {
    helpId:'dashboard',
    content: jsonContent.dashboardCardview,
  },
  {
    helpId:'dashboard_listview',
    content: jsonContent.dashboardListview,
  },
  {
    helpId: 'user-groups-help',
    content: jsonContent.userGroupsHelp,
  },
  {
    helpId: 'customer-user-groups-help',
    content: jsonContent.customerUserGroupsHelp,
  },
  {
    helpId:'customer-user-groups-help2',
    content:jsonContent.customerUserGroupsHelp2,
  },
  {
    helpId: 'user-groups-users-tab',
    content: jsonContent.userGroupsUsersTab,
  },
  {
    helpId: 'user-groups-customer-tab',
    content: jsonContent.userGroupsCustomerTab,
  },
  {
    helpId: 'user-groups-permission-tab',
    content: jsonContent.userGroupsPermissionTab,
  },
  {
    helpId: 'user-group-create-help',
    content: jsonContent.createUserGroup,
  },
  {
    helpId: 'activity-log-help',
    content: jsonContent.activityLogHelp,
  },
  {
    helpId: 'download-center',
    content: jsonContent.downloadCenterHelp,
  },
  {
    helpId: 'master-mssp',
    content: jsonContent.masterMsspUserGuide,
  },
  {
    helpId: 'regular-mssp',
    content: jsonContent.regularMsspUserGuide,
  },
  {
    helpId: 'regular-billing-report',
    content: jsonContent.regularBillingReport,
  },
  {
    helpId: 'master-billing-report',
    content: jsonContent.masterBillingReport,
  },
  {
    helpId: 'renewal-manager',
    content: jsonContent.renewalManagerHelpGuide,
  },
  {
    helpId: 'notification-center',
    content: jsonContent.notificationCenterHelpGuide,
  },
  {
    helpId: 'download-signatures',
    content: jsonContent.downloadSignaturesHelpGuide,
  },
  {
    helpId: 'nfr-services',
    content: jsonContent.nfrServicesHelpGuide,
  },
  {
    helpId: 'psa-integration',
    content: jsonContent.psaIntegrationHelpGuide,
  },
  {
    helpId: 'psa-connectwise',
    content: jsonContent.cwIntegrationHelpGuide,
  },
  {
    helpId:'create-customers',
    content: jsonContent.createCustomer,
  },
  {
    helpId:'register-products-1',
    content: jsonContent.registerProduct1,
  },
  {
    helpId:'register-products-2',
    content: jsonContent.registerProduct2,
  },
  {
    helpId:'register-default',
    content: jsonContent.registerProduct98,
  },
  {
    helpId:'registerUTMStep1',
    content: jsonContent.registerUTMStep1,
  },
  {
    helpId:'registerUTMStep2',
    content: jsonContent.registerUTMStep2,
  },
  {
    helpId:'registerSATA1',
    content: jsonContent.registerSATA1,
  },
  {
    helpId:'registerSATA2',
    content: jsonContent.registerSATA2,
  },
  {
    helpId:'registerHES1',
    content: jsonContent.registerHES1,
  },
  {
    helpId:'registerHES2',
    content: jsonContent.registerHES2,
  },
  {
    helpId:'registerHES3',
    content: jsonContent.registerHES3,
  },
  {
    helpId:'registerSonicwave1',
    content: jsonContent.registerSonicwave1,
  },
  {
    helpId:'registerSonicwave2',
    content: jsonContent.registerSonicwave2,
  },
  {
    helpId:'registerSoho1',
    content: jsonContent.registerSoho1,
  },
  {
    helpId:'registerWaf1',
    content: jsonContent.registerWaf1,
  },
  {
    helpId:'registerVpn1',
    content: jsonContent.registerVpn1,
  },
  {
    helpId:'registerGms1',
    content: jsonContent.registerGms1,
  },
  {
    helpId:'registerCas1',
    content: jsonContent.registerCas1,
  },
  {
    helpId:'registerCas2',
    content: jsonContent.registerCas2,
  },
  {
    helpId:'registerSonicwallUpgrade1',
    content: jsonContent.registerSonicwallUpgrade1,
  },
  {
    helpId:'registerCompitativeUpgrade1',
    content: jsonContent.registerCompitativeUpgrade1,
  },
  {
    helpId:'registerSonicwallUpgrade2',
    content: jsonContent.registerSonicwallUpgrade2,
  },
  {
    helpId:'registerCompitativeUpgrade2',
    content: jsonContent.registerCompitativeUpgrade2,
  },
  {
    helpId:'registerHighAvaliability1',
    content: jsonContent.registerHighAvaliability1,
  },
  {
    helpId:'bulkRegistration',
    content: jsonContent.bulkRegistration,
  },
  {
    helpId:'genericRegisterHelp',
    content: jsonContent.genericRegisterHelp,
  },
  {
    helpId:'genericRegisterHelp3',
    content: jsonContent.genericRegisterHelp3,
  },
  {
    helpId: 'master-mssp-access-mgmt',
    content: jsonContent.masterMsspAccessMgmtUserGuide,
  },
  {
    helpId: 'regular-mssp-access-mgmt',
    content: jsonContent.regularMsspAccessMgmtUserGuide,
  },
  {
    helpId: 'external-idp',
    content: jsonContent.externalIDPGuide,
  },
  {
    helpId: 'catalog',
    content: jsonContent.catalogHelp,
  },
  {
    helpId: 'freedownloads',
    content: jsonContent.freedownloadsHelp,
  },
  {
    helpId: 'quotehistory',
    content: jsonContent.quotehistoryHelp,
  },
  {
    helpId: 'managecases',
    content: jsonContent.managecasesHelp,
  },
  {
    helpId: 'product-claims',
    content: jsonContent.productClaimsHelp,
  },
  {
    helpId: 'org-account',
    content: jsonContent.orgAccountHelp,
  },
];
